import { useContext } from "react";

import { isResponseOk, useFetch } from "@swa-ui/fetch";

import { AuthContext } from "../../AuthProvider";

export const useMissingCorporateInformationServices = () => {
  const { loading, put, response } = useFetch("/api/security/v3/security/corporate/travelers");
  const { auth } = useContext(AuthContext);

  return {
    loading,
    saveMissingCorporateInformation,
  };

  async function saveMissingCorporateInformation() {
    let callStatus = { ok: true };

    const body = await put("missing-information", {
      accountNumber: auth["customers.userInformation.accountNumber"],
      companyId: auth["corporate.companyUserInformation.companyId"],
      member: {
        contactEmail: auth["customers.userInformation.primaryEmail"],
        contactPhoneNumber: auth["customers.userInformation.primaryPhoneNumber"],
        firstName: auth["customers.userInformation.firstName"],
        lastName: auth["customers.userInformation.lastName"],
      },
    });

    if (!isResponseOk(response)) {
      callStatus = { errorCode: body.code, ok: false };
    }

    return { callStatus };
  }
};
